import axiosInstance from "../lib/axiosInstance";
import axiosInstanceNew from "lib/axiosinstanceNew";

const EnquiryModal = class {
  constructor() {
    this.baseUrl = "/adminapi/enquiry/";
  }

  async listEnquiry(query = []) {
    return (
      await axiosInstance.get(`${this.baseUrl}?${new URLSearchParams(query)}`)
    ).data;
  }

  // async listPendingEnquiry(query = []) {
  // return (
  //  await axiosInstance.get(`/adminapi/penenq/?${new URLSearchParams(query)}`)
  //).data;
  //}
  // make new equary
  async Addnewequriey() {
    // Return dummy data for new enquiries count
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: 15, // Dummy count
        });
      }, 500);
    });
    // return (
    //   await axiosInstanceNew.get(`tutor_enquiry?status=new_enq`)
    // ).data;
  }

  async listAllNewEnquiry(query = []) {
    return (
      await axiosInstanceNew.get(
        `tutor_enquiry?status=new_enq&${new URLSearchParams(query)}`
      )
    ).data;
  }
  //get detail of parent detail by id
  async getdetail(id) {
    return (await axiosInstanceNew.get(`tutor_enquiry/${id}`)).data;
  }
  async getdetails(id) {
    return (await axiosInstanceNew.get(`tutor_enquiry?tutor_id=${id}`)).data;
  }
  // get qualify list
  async QualifiedEnquiry(query = []) {
    // Return dummy data for qualified enquiries count
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: 8, // Dummy count
        });
      }, 500);
    });
    // return (
    //   await axiosInstanceNew.get(`tutor_enquiry?status=qualified_enq&${new URLSearchParams(query)}`)
    // ).data;
  }
  async QualifiedEnquirylimt(query = []) {
    return (
      await axiosInstanceNew.get(
        `tutor_enquiry?status=qualified_enq&limit=5000${new URLSearchParams(
          query
        )}`
      )
    ).data;
  }
  // get disquality
  async Disqualify(query = []) {
    // Return dummy data for disqualified enquiries count
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: 5, // Dummy count
        });
      }, 500);
    });
    // return (
    //   await axiosInstanceNew.get(`tutor_enquiry?status=disqualified_enq&${new URLSearchParams(query)}`)
    // ).data;
  }
  // get pendinglist
  async Pendingss(query = []) {
    // Return dummy data for pending enquiries count
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: 12, // Dummy count
        });
      }, 500);
    });
    // return (
    //   await axiosInstanceNew.get(`tutor_enquiry?status=pending_enq&${new URLSearchParams(query)}`)
    // ).data;
  }
  async detail(id) {
    return (await axiosInstanceNew.get(`tutor_enquiry/${id}`)).data;
  }
  //mark as qualified
  async qualified(id, data = []) {
    return await axiosInstanceNew.put(`tutor_enquiry/${id}`, data);
  }
  // mark as pending
  async pending(id, data = []) {
    return await axiosInstanceNew.put(`tutor_enquiry/${id}`, data);
  }
  // mark as disqualify
  async disqualify(id, data = []) {
    return await axiosInstanceNew.put(`tutor_enquiry/${id}`, data);
  }
  async editParentDeatils(data = []) {
    return await axiosInstance.put(`adminapi/edit_parent/`, data);
  }

  async editStudentDeatils(data = []) {
    return await axiosInstance.put(`/adminapi/edit_student/`, data);
  }

  async listNewEnquiry(query = []) {
    return (
      await axiosInstance.get(`/adminapi/newenq/?${new URLSearchParams(query)}`)
    ).data;
  }

  async listDisqEnquiry(query = []) {
    return (
      await axiosInstance.get(`/adminapi/disenq/?${new URLSearchParams(query)}`)
    ).data;
  }

  async listQulEnquiry(query = []) {
    return (
      await axiosInstance.get(
        `/adminapi/qlfydenq/?${new URLSearchParams(query)}`
      )
    ).data;
  }

  async listEnquiryStatus(data, status) {
    return (
      await axiosInstance.get(
        `${this.baseUrl}?${new URLSearchParams(data)}&status=${status}`
      )
    ).data;
  }

  async parentDetails(data) {
    return (await axiosInstance.get(`/adminapi/parent_detail/?mobile=${data}`))
      .data;
  }

  async StudentDetails(data) {
    return (await axiosInstance.get(`/adminapi/student_detail/?id=${data}`))
      .data;
  }

  async parentStudentget(data) {
    return (await axiosInstance.get(`/adminapi/student_list/?id=${data}`)).data;
  }

  async AssignEnquriesTutors(data) {
    console.log(data, "classmodal");
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const jsonData = JSON.stringify(data);
      const response = await axiosInstance.post(this.baseUrl, jsonData, {
        headers,
      });
      return response.data;
    } catch (error) {
      console.error("Error creating class:", error);
      throw error; // Rethrow the error for handling at the calling site
    }
  }
  async AssignEnquriesStatusChange(data) {
    console.log(data, "classmodal");
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const jsonData = JSON.stringify(data);
      const response = await axiosInstance.put(this.baseUrl, jsonData, {
        headers,
      });
      return response.data;
    } catch (error) {
      console.error("Error creating class:", error);
      throw error; // Rethrow the error for handling at the calling site
    }
  }

  async enquriesStatusChangeQulif(data) {
    try {
      const headers = {
        "Content-Type": "application/json",
      };
      const jsonData = JSON.stringify(data);
      const response = await axiosInstance.put("/update_enq/", jsonData, {
        headers,
      });
      return response.data;
    } catch (error) {
      throw error; // Rethrow the error for handling at the calling site
    }
  }

  async enquriesStatusChange(data = []) {
    return await axiosInstance.put(`/update_enq/`, data);
  }

  async deleteclass(data = {}) {
    return await axiosInstance.delete(`${this.baseUrl}?id=${data}`);
  }

  async deleteStudent(data = {}) {
    return await axiosInstance.delete(
      `/delete_student/?id=${data.id}&sid=${data.sid}`
    );
  }
  async EnquiryAssignTotursview(id = {}) {
    return await axiosInstance.get(`${this.baseUrl}?id=${id}`);
  }
};

export default new EnquiryModal();
